import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-monokai';
import { toast } from 'react-toastify';
import CustomLoader from '../common/CustomLoader';

export class JsEditor extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    editorvalue: '',
    isEditing: false,
  };
  handleCustomJsCdnDelete = async () => {
    const { projectId, appSetting, version, actions } = this.props;

    try {
      await actions.deleteProjectCustomJsCdn({
        projectId: projectId,
        uuid: appSetting.jsuuid,
        noToast: true,
        version,
      });
      console.log('Custom JS file deleted successfully');
    } catch (error) {
      console.error('Error deleting custom JS file:', error);
    }
  };

  saveJsFile = async () => {
    const { projectId, appSetting, actions, version } = this.props;
    const JsContent = this.state.isEditing ? this.state.editorvalue : appSetting.jsEditorValue;
    const { urlOrTag } = appSetting.customJsCdnData;
    const endName = urlOrTag.split('/').pop();
    const blob = new Blob([JsContent], { type: 'application/javascript' });
    const formData = new FormData();
    formData.append('file', blob, `${appSetting.jsuuid}/${endName}`);
    formData.append('customJsCdnData', JSON.stringify(appSetting.customJsCdnData));
    await actions.saveJsFile({
      projectId: projectId,
      version,
      jsuuid: appSetting.jsuuid,
      formData: formData,
      customJsCdnData: appSetting.customJsCdnData,
    });
  };

  handleSave = async () => {
    await this.handleCustomJsCdnDelete();
    await this.saveJsFile();
    toast.success('JS file Updated Successfully !');
    const { projectId, actions, version } = this.props;
    actions.loadCustomJsCdns({ projectId, version });
    actions.toggleJsEditorModal();
  };
  handleStartEditing = () => {
    this.setState({ isEditing: true, editorvalue: this.props.appSetting.jsEditorValue });
  };

  handleChange = (value) => {
    if (this.state.isEditing) {
      this.setState({ editorvalue: value });
    }
  };
  handleCancel = () => {
    const { actions } = this.props;
    actions.toggleJsEditorModal();
  };
  render() {
    const { appSetting } = this.props;
    const { deleteProjectCustomJsCdnPending, saveJsFilePending, loadCustomJsCdnsPending } =
      appSetting;
    const value = this.state.isEditing ? this.state.editorvalue : appSetting.jsEditorValue;
    return (
      <div className="cssEditorui">
        <div className="row">
          <div className="col-md-12 col-lg-12 col-sm-12 css1 ">
            <AceEditor
              mode="javascript"
              theme="github"
              value={value}
              name="code-editor1"
              width="100%"
              height="60vh"
              fontSize={15}
              wrapEnabled={true}
              showPrintMargin={false}
              readOnly={!this.state.isEditing}
              onChange={this.handleChange}
              onFocus={this.handleStartEditing}
            />
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <button
            className="btn btn-outline-secondary btn-md"
            title="Cancel"
            onClick={this.handleCancel}
          >
            <i className="wb webconnect-times"></i> Cancel
          </button>
          <button
            className="btn btn-theme-submit btn-md"
            title="Update"
            onClick={this.handleSave}
            disabled={
              deleteProjectCustomJsCdnPending || saveJsFilePending || loadCustomJsCdnsPending
            }
          >
            <i className="wb webconnect-save-regular"></i> Update
            <CustomLoader
              loading={
                deleteProjectCustomJsCdnPending || saveJsFilePending || loadCustomJsCdnsPending
              }
            />
          </button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(JsEditor);
